
export const selectors = {
    docId: (state: any) => state.meta.docId as string,
    docName: (state: any) => state.meta.docName as string,
    pageCount: (state: any) => state.meta.pageCount as number,
    pageId: (state: any) => state.meta.pageId as number,
    pageName: (state: any) => state.meta.pageName as string,
    pageNumber: (state: any) => state.meta.pageNumber as number,
    pageUrl: (state: any) => state.meta.pageUrl as string,
    tenantId: (state: any) => state.meta.tenantId as string,
    tenantName: (state: any) => state.meta.tenantName as string,
    breadcrumb: (state: any) => state.meta.breadcrumb as string,    
    mailToName: (state: any) => state.meta.mailToName as string,
    mailToAddress: (state: any) => state.meta.mailToAddress as string,
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/meta/selectors.tsx